// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import initialiseElementTypes from '../element/initialiseElementTypes';
import { isInIFrame } from '../utils/services/iframe';

// Utils
import { getIsSwiftHybrid } from '../hybridApp/hybridAppUtils';
import getClientConfig from '../utils/getClientConfig';

// Selectors
import { getIsLocalCacheHydrated } from '../offline/cache/localCacheSelector';

// Decorators
import debugManagerDecorator from '../debug/debugManagerDecorator';

// Components
import BrowserDetection from '../components/error/browserSupport/BrowserDetection';
import PwaDetection from '../pwaApp/PwaDetection';
import GridSizeManager from '../utils/grid/GridSizeManager';
import ThemeManager from '../user/account/accountModal/interface/themeSettings/ThemeManager';
import InterfaceSettingsManager from '../user/account/accountModal/interface/InterfaceSettingsManager';
import HeadingStyleManager from '../user/account/accountModal/interface/HeadingStyleManager';
import IconPreloader from './initialisation/IconPreloader';
import OneTrustInit from './oneTrust/OneTrustInit';

// Styles
import './AppInit.scss';

// Constants
import { APP_DID_REHYDRATE_FROM_LOCAL_CACHE } from '../offline/appServerConnection/appServerReconnectionStatusConstants';

const inIframe = isInIFrame();
initialiseElementTypes();

const mapDispatchToProps = (dispatch) => ({
    dispatchAppConnectionStatusActive: () => dispatch({ type: APP_DID_REHYDRATE_FROM_LOCAL_CACHE }),
});

const mapStateToProps = createStructuredSelector({
    isLocalCacheHydrated: getIsLocalCacheHydrated,
});

@debugManagerDecorator
class AppInitContainer extends React.Component {
    componentDidMount() {
        if (this.props.isLocalCacheHydrated) this.props.dispatchAppConnectionStatusActive();
    }

    render() {
        const loadOneTrust = !getIsSwiftHybrid() && !getClientConfig().disableThirdPartyResources;

        return (
            <div className={classNames('App', { 'in-iframe': inIframe })}>
                {this.props.children}
                <BrowserDetection {...this.props} />
                <PwaDetection />
                <GridSizeManager />
                <HeadingStyleManager />
                <ThemeManager />
                <InterfaceSettingsManager />
                <IconPreloader />
                {loadOneTrust && <OneTrustInit />}
            </div>
        );
    }
}

AppInitContainer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    dispatchAppConnectionStatusActive: PropTypes.func,

    isLocalCacheHydrated: PropTypes.bool,
    isPreviewRoute: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppInitContainer);
